module.exports = __webpack_public_path__ + "static/media/2_18.89456dc0.png";